// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#form-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

#form-inner-container {
  width: 100%;
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 0 0 20px gainsboro; */
}

#sign-up-container,
#sign-in-container {
  padding: 60px 80px;
  width: 50%;
  display: inline-block;
}

.contact__form input:not(:last-of-type) {
  display: block;
  margin-bottom: 20px;
  border: 1px solid #e5e9f5;
  background-color: #f6f7fa;
  padding: 20px;
  margin-top: 10px;
  border-radius: 10px;
  width: 100%;
}

#form-controls {
  margin-bottom: 20px;
}

.contact__form__h3 {
  color: red;
  font-size: 150%;
  font-weight: 500;
}

.contact__form__label {
  color: #7369ab;
}

.contact__form input::placeholder {
  color: #c0c7db;
  font-size: larger;
  letter-spacing: 1.2px;
}

#form-controls button {
  border: none;
  font-size: 120%;
}

#form-controls button:hover {
  cursor: pointer;
}

.contact__form__button__submit {
  padding: 16px 75px;
  background-color: #dd4498;
  border-radius: 5px;
  color: white;
}

.contact__form__button__submit:hover {
  background-color: #dd4498;
}

.contact__form__button__btn {
  padding: 16px 0 16px 35px;
  background-color: transparent;
  color: #ed4b5e;
}

#terms {
  width: 30px;
  height: 30px;
  appearance: none;
  border: 2px solid #7369ab;
  border-radius: 4px;
  position: relative;
}

#terms:checked:after {
  content: "\\2713";
  color: #7369ab;
  font-size: 24px;
  position: absolute;
  top: 0;
  left: 3px;
}

label[for="terms"] {
  display: inline-block;
  width: 80%;
  margin-left: 10px;
}

.termsLink {
  color: #ef7886;
  text-decoration: none;
}

.hide {
  display: none !important;
}

#animation-container {
  display: inline-block;
}

/* responsive display */

@media (max-width: 1438px) {
  lottie-player {
    width: 300px !important;
  }
}

@media (max-width: 1124px) {
  #animation-container {
    display: none;
  }

  #form-inner-container {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 684px) {
  #form-controls {
    text-align: center;
    margin: 0;
    padding: 0;
  }

  button {
    /* width: 100%; */
  }

  form input:not(:last-of-type) {
    width: 85%;
  }

  #toggleSignIn,
  #toggleSignUp {
    padding: 16px 75px;
  }

  #terms {
    width: 20px;
    height: 20px;
  }

  label[for="terms"] {
    display: inline-block;
    font-size: smaller;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Landing/formstyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;;AAEvB;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;AACF","sourcesContent":["#form-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#form-inner-container {\n  width: 100%;\n  background-color: white;\n  border-radius: 8px;\n  /* box-shadow: 0 0 20px gainsboro; */\n}\n\n#sign-up-container,\n#sign-in-container {\n  padding: 60px 80px;\n  width: 50%;\n  display: inline-block;\n}\n\n.contact__form input:not(:last-of-type) {\n  display: block;\n  margin-bottom: 20px;\n  border: 1px solid #e5e9f5;\n  background-color: #f6f7fa;\n  padding: 20px;\n  margin-top: 10px;\n  border-radius: 10px;\n  width: 100%;\n}\n\n#form-controls {\n  margin-bottom: 20px;\n}\n\n.contact__form__h3 {\n  color: red;\n  font-size: 150%;\n  font-weight: 500;\n}\n\n.contact__form__label {\n  color: #7369ab;\n}\n\n.contact__form input::placeholder {\n  color: #c0c7db;\n  font-size: larger;\n  letter-spacing: 1.2px;\n}\n\n#form-controls button {\n  border: none;\n  font-size: 120%;\n}\n\n#form-controls button:hover {\n  cursor: pointer;\n}\n\n.contact__form__button__submit {\n  padding: 16px 75px;\n  background-color: #dd4498;\n  border-radius: 5px;\n  color: white;\n}\n\n.contact__form__button__submit:hover {\n  background-color: #dd4498;\n}\n\n.contact__form__button__btn {\n  padding: 16px 0 16px 35px;\n  background-color: transparent;\n  color: #ed4b5e;\n}\n\n#terms {\n  width: 30px;\n  height: 30px;\n  appearance: none;\n  border: 2px solid #7369ab;\n  border-radius: 4px;\n  position: relative;\n}\n\n#terms:checked:after {\n  content: \"\\2713\";\n  color: #7369ab;\n  font-size: 24px;\n  position: absolute;\n  top: 0;\n  left: 3px;\n}\n\nlabel[for=\"terms\"] {\n  display: inline-block;\n  width: 80%;\n  margin-left: 10px;\n}\n\n.termsLink {\n  color: #ef7886;\n  text-decoration: none;\n}\n\n.hide {\n  display: none !important;\n}\n\n#animation-container {\n  display: inline-block;\n}\n\n/* responsive display */\n\n@media (max-width: 1438px) {\n  lottie-player {\n    width: 300px !important;\n  }\n}\n\n@media (max-width: 1124px) {\n  #animation-container {\n    display: none;\n  }\n\n  #form-inner-container {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 684px) {\n  #form-controls {\n    text-align: center;\n    margin: 0;\n    padding: 0;\n  }\n\n  button {\n    /* width: 100%; */\n  }\n\n  form input:not(:last-of-type) {\n    width: 85%;\n  }\n\n  #toggleSignIn,\n  #toggleSignUp {\n    padding: 16px 75px;\n  }\n\n  #terms {\n    width: 20px;\n    height: 20px;\n  }\n\n  label[for=\"terms\"] {\n    display: inline-block;\n    font-size: smaller;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
